import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  // 变量存储库
  state: {
    token: ''
  },
  mutations: {
    // 设置vuex的token
    settoken (state, token) {
      state.token = token
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js